import * as React from "react";
const SvgFiRrWorkInProgress = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-work-in-progress_svg__a)">
      <path
        fill="#062147"
        d="M17.101 9.6h.5c.496 0 .9.404.9.9s-.404.9-.9.9h-.5zM24 12a5.7 5.7 0 0 1-1.681 4.058l-6.263 6.264A5.7 5.7 0 0 1 11.999 24a5.7 5.7 0 0 1-4.057-1.677L1.68 16.057A5.7 5.7 0 0 1-.002 12c0-1.534.597-2.975 1.681-4.058l6.264-6.264a5.745 5.745 0 0 1 8.113 0l6.263 6.266A5.7 5.7 0 0 1 24 12m-6.456-4H16.3a.8.8 0 0 0-.8.8v6.401a.8.8 0 1 0 1.6 0V13h.5a2.5 2.5 0 0 0 2.5-2.452C20.127 9.147 18.946 8 17.544 8M6.45 6H17.55l-2.907-2.908A3.73 3.73 0 0 0 11.999 2c-.957 0-1.914.364-2.643 1.092zm6.85 2a.8.8 0 0 0-.8.8v6.401a.8.8 0 1 0 1.6 0V8.8a.8.8 0 0 0-.8-.8m-6.695 7.361 1.164-2.56 1.164 2.56c.181.398.5.64.841.64.516 0 .945-.295.988-1l.445-6.143a.8.8 0 1 0-1.596-.116l-.265 3.66-.849-1.867a.8.8 0 0 0-1.457 0l-.848 1.867-.265-3.66a.8.8 0 0 0-1.596.116l.445 6.143c.043.705.472 1 .988 1 .342 0 .66-.242.841-.64m10.943 2.641H6.452l2.905 2.906c1.408 1.408 3.877 1.409 5.285 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-work-in-progress_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWorkInProgress;
